@if (!isHidden) {
  <div class="pnc-solution pnc-solution-trial requires-flashing DetailSolution " data-cy="pnc-detail-solution">
    <div class="pnc-detail-trial-title-requires-flashing"
      data-cy="pnc-detail-trial-title-requires-flashing">Solution <span class="pnc-detail-trial-solution-title">{{solutionTrials.data.title | undefinedValue}}</span></div>
      <div class="pnc-solution-checkbox-wrapper" data-cy="pnc-solution-checkbox-wrapper">
        <input type="checkbox"
          [checked]="true"
          [disabled]="true"
          data-cy="checkbox-eeSpecialist"
          class="pnc-solution-checkbox-input"/><span class="pnc-solution-checkbox-text"
        data-cy="pnc-solution-checkbox-text">Does the solution demand software flashing?</span>
      </div>
      <div class="pnc-solution-new-part-number-container"
        data-cy="pnc-solution-new-part-number-container">
      <app-part-number-changes-detail-pnc-solution-new-part-number [isInViewMode]="true"
        [isDetailSolvedTrial]="true"
        [material]="$safeNavigationMigration(solutionTrials?.data?.newPartNumber)"
        (newPartChange)="newPartChange($event)"
                                                                         [materialWarningLevel]="warningLevel($safeNavigationMigration(solutionTrials?.
                                                                     displayConfiguration?.materialInput.required))"
                                                                         [quantityWarningLevel]="warningLevel($safeNavigationMigration(solutionTrials?.
                                                                     displayConfiguration?.quantityInput.required))">
      </app-part-number-changes-detail-pnc-solution-new-part-number>
      @for (additionalParts of solutionTrials.data.additionalMaterials; track trackByItem(index, additionalParts); let index = $index) {
        <app-part-number-changes-detail-pnc-solution-new-part-number
          [additionalIndex]="index + 1"
          [isInViewMode]="true"
          [isDetailSolvedTrial]="true"
          [material]="additionalParts">
        </app-part-number-changes-detail-pnc-solution-new-part-number>
      }
      <div class="pnc-solution-additional-information"
        data-cy="pnc-detail-solution-additional-information">
        <app-input-textarea
                        [initialValue]="initialValuePipe(solutionTrials?.displayConfiguration.additionalInformation.displayMode,
                $safeNavigationMigration(solutionTrials?.data?.additionalInformation))"
          [showViewMode]="true"
          baseCypressTag="pnc-detail-solution-additional-information"
          height="88"
          label="Additional information"
          maxLength="400"
        placeholder="Write an additional information"></app-input-textarea>
      </div>
    </div>
    <div class="pnc-detail-body-output-field-label pnc-detail-body-output-field-value-tried-by"><span data-cy="pnc-detail-solution-tried-by-label">Tried by</span></div>
    <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email" data-cy="pnc-detail-solution-tried-by-value">{{$safeNavigationMigration(solutionTrials?.data?.sentBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
  </div>
  <div class="trial-rejection trial-rejection-margin">
    <app-part-number-changes-reject-motivation
      [trialWrapperStyle]="rejectWrapperStyle"
      [trialRejectionMotivation]="$safeNavigationMigration(solutionTrials?.data?.trialRejectionDetail)">
    </app-part-number-changes-reject-motivation>
  </div>
}
